import type { CarImage } from '@autobid/ui/types/Car'

const SHOW_GALLERY_KEY = 'showCarGallery'

export function useCarGallery() {
  const injectShowGallery = () => {
    return inject<Ref<boolean>>(SHOW_GALLERY_KEY, ref(false))
  }

  const provideShowGallery = (value: Ref<boolean>) => {
    return provide(SHOW_GALLERY_KEY, value)
  }

  const openCarGallery = (links: CarImage['links']) => {
    nextTick(() => {
      const btn: HTMLButtonElement | null = document.querySelector(
        `button[data-src="${links.hd}"]`,
      )

      if (!btn) {
        return
      }

      btn.click()
    })
  }

  return { injectShowGallery, provideShowGallery, openCarGallery }
}
